module.exports = __webpack_public_path__ + "img/16.missing_toilet_paper.85f384e4.svg";